import {
  Box, Card, CardContent, Typography, Button, Table, TableBody,
  TableCell, TableHead, TableRow, Chip, IconButton, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField,
} from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import { useState, useEffect, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import api from '../../api/axios';
import { showSnackbar } from '../ui/uiSlice';

export default function BrandsPage() {
  const dispatch = useDispatch();
  const [brands, setBrands] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  const load = useCallback(() => api.get('/brands').then(r => setBrands(r.data.data)), []);
  useEffect(() => { load(); }, [load]);

  const openDialog = (b = null) => { setEditing(b); reset(b || {}); setDialogOpen(true); };

  const onSubmit = async (data) => {
    try {
      if (editing) await api.put(`/brands/${editing.id}`, data);
      else await api.post('/brands', data);
      dispatch(showSnackbar({ message: editing ? 'Brand updated' : 'Brand created', severity: 'success' }));
      setDialogOpen(false); load();
    } catch (e) {
      dispatch(showSnackbar({ message: 'Error', severity: 'error' }));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this brand?')) return;
    await api.delete(`/brands/${id}`);
    dispatch(showSnackbar({ message: 'Brand deleted', severity: 'success' }));
    load();
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight={700}>Brands</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={() => openDialog()}>Add Brand</Button>
      </Box>

      <Card>
        <CardContent>
          <Table size="small">
            <TableHead><TableRow>
              <TableCell>Name</TableCell>
              <TableCell>اردو نام</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow></TableHead>
            <TableBody>
              {brands.map(b => (
                <TableRow key={b.id} hover>
                  <TableCell><Typography fontWeight={600}>{b.name}</Typography></TableCell>
                  <TableCell dir="rtl">{b.name_ur}</TableCell>
                  <TableCell>{b.description}</TableCell>
                  <TableCell><Chip label={b.is_active ? 'Active' : 'Inactive'} size="small" color={b.is_active ? 'success' : 'default'} /></TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => openDialog(b)}><Edit fontSize="small" /></IconButton>
                    <IconButton size="small" color="error" onClick={() => handleDelete(b.id)}><Delete fontSize="small" /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {brands.length === 0 && (
                <TableRow><TableCell colSpan={5} align="center"><Typography color="text.secondary" py={3}>No brands yet</Typography></TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>{editing ? 'Edit Brand' : 'Add Brand'}</DialogTitle>
        <DialogContent>
          <Box component="form" id="brand-form" onSubmit={handleSubmit(onSubmit)} sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField fullWidth label="Brand Name *" {...register('name', { required: true })} error={!!errors.name} />
            <TextField fullWidth label="اردو نام" {...register('name_ur')} inputProps={{ dir: 'rtl' }} />
            <TextField fullWidth label="Description" {...register('description')} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" type="submit" form="brand-form">Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
